import { useEffect } from 'react';
import { API_BASE_URL } from '../constants/api';

// Landing page for https://mytrustlab.com/app — the URL the printed QR
// code encodes.
//
// Why this page exists at all: `/app` is not an `/api` path, so on the
// live domain it falls through to this React SPA (exactly like
// `/app-privacy`, which the stores already use). The device-detection
// itself is NOT duplicated here — we hand straight over to the backend,
// which reads the same User-Agent and sends Android to Play Store and
// iPhone to the App Store, using the URLs an admin can edit in the
// admin panel. One decision point, no second copy to drift out of sync.
//
// The redirect is fired from an effect rather than during render so it
// still happens if React re-mounts the route, and `location.replace`
// (not `assign`) keeps this page out of the back-stack — otherwise
// pressing Back from the store bounces the user straight forward again.
const STORE_REDIRECT_URL = `${API_BASE_URL.replace(/\/$/, '')}/app`;

const AppRedirect = () => {
  useEffect(() => {
    window.location.replace(STORE_REDIRECT_URL);
  }, []);

  // Shown for the moment before the redirect fires, and permanently if
  // the browser blocks scripted navigation.
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <div>
        <p style={{ fontSize: '1.05rem', marginBottom: '.75rem' }}>
          Opening the TrustLab app store page&hellip;
        </p>
        <a href={STORE_REDIRECT_URL} style={{ color: '#1b4d8f', fontWeight: 600 }}>
          Tap here if nothing happens
        </a>
      </div>
    </div>
  );
};

export default AppRedirect;
